import { FC } from 'react';
import { Navigate, Route as ReactRouterRoute, Routes } from 'react-router-dom';

import {
  AccountActivationPage,
  AuthRoute,
  ConditionalRoute,
  CreateAccountPage,
  DirectLoginPage,
  EnterBarcodePage,
  EnterNewPinPage,
  LoginPage,
  LogoutPage,
  MainPage,
  PreregistrationPage,
  ResendVerificationLinkPage,
  SSOPage,
} from '@app/components';
import { Feature, Route } from '@app/constants';

export const AppRoutes: FC = () => (
  <Routes>
    <ReactRouterRoute
      path={Route.login}
      element={
        <AuthRoute>
          <LoginPage />
        </AuthRoute>
      }
    />
    <ReactRouterRoute
      path={Route.createAccount}
      element={
        <ConditionalRoute flagToMatch={{ name: Feature.preregistration }}>
          <AuthRoute>
            <CreateAccountPage />
          </AuthRoute>
        </ConditionalRoute>
      }
    />
    <ReactRouterRoute
      path={Route.accountActivation}
      element={
        <ConditionalRoute flagToMatch={{ name: Feature.preregistration }}>
          <AuthRoute>
            <AccountActivationPage />
          </AuthRoute>
        </ConditionalRoute>
      }
    />
    <ReactRouterRoute
      path={Route.preregistration}
      element={
        <ConditionalRoute flagToMatch={{ name: Feature.preregistration }}>
          <AuthRoute>
            <PreregistrationPage />
          </AuthRoute>
        </ConditionalRoute>
      }
    />
    <ReactRouterRoute
      path={Route.resendVerificationLink}
      element={
        <ConditionalRoute flagToMatch={{ name: Feature.preregistration }}>
          <AuthRoute>
            <ResendVerificationLinkPage />
          </AuthRoute>
        </ConditionalRoute>
      }
    />
    <ReactRouterRoute
      path={Route.directLogin}
      element={
        <AuthRoute>
          <DirectLoginPage />
        </AuthRoute>
      }
    />
    <ReactRouterRoute path={Route.logout} element={<LogoutPage />} />
    <ReactRouterRoute
      path={Route.sso}
      element={
        <AuthRoute>
          <SSOPage />
        </AuthRoute>
      }
    />
    <ReactRouterRoute
      path={Route.enterNewPin}
      element={
        <AuthRoute>
          <EnterNewPinPage />
        </AuthRoute>
      }
    />
    <ReactRouterRoute
      path={Route.resetPinRoot}
      element={<Navigate replace to={Route.enterBarcode} />}
    />
    <ReactRouterRoute
      path={Route.enterBarcode}
      element={
        <AuthRoute>
          <EnterBarcodePage />
        </AuthRoute>
      }
    />
    <ReactRouterRoute path="*" element={<MainPage />} />
  </Routes>
);
